import { useMemo } from "react";

import { getBasketballPlayerLabel, getHockeyPlayerLabel, getSoccerPlayerLabel } from "../../config";
import { PositionLabelType } from "../../pages";
import { Sport } from "../../redux/slices";
import {
  HockeyPlayerLabelType,
  SoccerPlayerLabelType,
  basketballPlayerIdNumbers,
  hockeyPlayerIdNumbers,
  soccerPlayerIdNumbers,
} from "../../types";

export interface FastPlacePlayers {
  playerIdNumbers: number[];
  getPlayerLabel: (player: number) => string;
}

export interface UseGetFastPlaceBasketballPlayersProps {
  sport: Sport.BASKETBALL;
}

export interface UseGetFastPlaceHockeyPlayersProps {
  sport: Sport.HOCKEY;
  playerLabelType: HockeyPlayerLabelType;
}

export interface UseGetFastPlaceSoccerPlayersProps {
  sport: Sport.SOCCER;
  playerLabelType: SoccerPlayerLabelType;
}

export type UseGetFastPlacePlayersProps =
  | UseGetFastPlaceBasketballPlayersProps
  | UseGetFastPlaceHockeyPlayersProps
  | UseGetFastPlaceSoccerPlayersProps;

export const useGetFastPlacePlayers = ({ sport, labelType }: PositionLabelType) => {
  const { playerIdNumbers, getPlayerLabel } = useMemo((): FastPlacePlayers => {
    switch (sport) {
      case Sport.BASKETBALL:
        return { playerIdNumbers: basketballPlayerIdNumbers, getPlayerLabel: getBasketballPlayerLabel };
      case Sport.HOCKEY:
        return { playerIdNumbers: hockeyPlayerIdNumbers, getPlayerLabel: getHockeyPlayerLabel({ labelType }) };
      case Sport.SOCCER:
        return { playerIdNumbers: soccerPlayerIdNumbers, getPlayerLabel: getSoccerPlayerLabel({ labelType }) };
    }
  }, [sport, labelType]);

  return { playerIdNumbers, getPlayerLabel };
};
